export const DOCUMENT_UPLOAD_FORMATS = [
  "pdf",
  "xls",
  "xlsx",
  "doc",
  "docx",
  "xml",
  "csv",
];

export const DOCUMENT_IMAGE_UPLOAD_FORMATS = [
  ...DOCUMENT_UPLOAD_FORMATS,
  "jpg",
  "jpeg",
  "png",
];

export const DOCUMENT_UPLOAD_ACCEPT = DOCUMENT_UPLOAD_FORMATS
  .map((format) => `.${format}`)
  .join(",");

export const DOCUMENT_IMAGE_UPLOAD_ACCEPT = DOCUMENT_IMAGE_UPLOAD_FORMATS
  .map((format) => `.${format}`)
  .join(",");

export const DOCUMENT_UPLOAD_FORMAT_LABEL = "PDF, XLS, XLSX, Word, XML, CSV";

export const DOCUMENT_IMAGE_UPLOAD_FORMAT_LABEL =
  "PDF, XLS, XLSX, Word, XML, CSV, JPG, JPEG, PNG";

export const getUploadFileExtension = (name = "") =>
  String(name).split(".").pop().toLowerCase();

export const isDocumentUploadFile = (file) =>
  Boolean(file && DOCUMENT_UPLOAD_FORMATS.includes(getUploadFileExtension(file.name)));

export const isDocumentImageUploadFile = (file) =>
  Boolean(file && DOCUMENT_IMAGE_UPLOAD_FORMATS.includes(getUploadFileExtension(file.name)));
